module.exports = __webpack_public_path__ + "static/media/process_2.258617b9.png";